/**
 * Provenance schemas — supervision review events.
 *
 * Enum arrays are tied to fhir-model types via `satisfies`.
 */
import { z } from 'zod';
import type { ProvenanceActivityCode as FhirProvenanceActivityCode } from '@unify/fhir-model/resources/provenance';

/** Supervision provenance activity codes — synced with fhir-model. */
export const provenanceActivityCodeValues = [
  'reviewed',
  'approved',
  'requested-edits',
  'cosigned',
  'rejected',
  'comment-added',
  'note-edited',
] as const satisfies readonly FhirProvenanceActivityCode[];

/**
 * Record a supervision review action on a QuestionnaireResponse.
 */
export const supervisionReviewSchema = z.object({
  questionnaireResponseId: z.string().min(1, 'Note ID is required'),
  reviewerId: z.string().min(1, 'Reviewer is required'),
  activityCode: z.enum(provenanceActivityCodeValues),
  detail: z.string().optional(),
});

export type SupervisionReviewInput = z.infer<typeof supervisionReviewSchema>;
